export default __webpack_public_path__ + "static/media/close-menu.563a8b44.svg";